export default __webpack_public_path__ + "static/media/avatar_default.25b6d96e.svg";